//
//
//
//
//
//

import {base} from '../../common/mixins'

export default {
  name: 'Picker',
  mixins: [ base ],
  porps: {

  },
  data () {
    return {
    }
  },
  mounted () {
  },
}



// WEBPACK FOOTER //
// ./src/components/hippius/components/Picker/index.vue